/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ZapierSampleData } from './ZapierSampleData';
export type ZapierSamplePayload = {
  event_type: ZapierSamplePayload.event_type;
  event_id: string;
  occurred_at: string;
  data: ZapierSampleData;
};
export namespace ZapierSamplePayload {
  export enum event_type {
    COMPANYMEASUREMENTDATE_CREATED = 'companymeasurementdate.created',
  }
}
